import { render } from "./StatusLogs.vue?vue&type=template&id=1006b48e&scoped=true"
import script from "./StatusLogs.vue?vue&type=script&lang=js"
export * from "./StatusLogs.vue?vue&type=script&lang=js"

import "./StatusLogs.vue?vue&type=style&index=0&id=1006b48e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1006b48e"]])

export default __exports__